import themeGet from '@styled-system/theme-get';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const TileInfoBanner = styled.div`
  margin: ${margin => margin || '24px'};
  padding: 16px 0px;
  background: ${themeGet('colors.black.80')};
  text-align: center;
  color: ${themeGet('colors.white')};
  font-family: 'Montserrat', sans-serif;
`;

const TileInfoBannerText = styled.span`
  font-weight: 600;
  font-size: 16px;
  vertical-align: middle;
`;

const AnonymousWord = styled(TileInfoBannerText)`
  position: relative;
`;

const AnonymousBannerComponent = ({ margin }) => {
  const { t } = useTranslation('tiles');
  return (
    <TileInfoBanner margin={margin}>
      <TileInfoBannerText>{t('anonymousBanner.bannerText')}</TileInfoBannerText>
      <AnonymousWord
        data-class="react-anonymous-banner"
        data-multiline={true}
        data-offset="{'top': 5, 'left': 60}"
        data-effect="solid"
        data-type="light"
        data-tip={t('anonymousBanner.tooltip')}
      >
        {t('anonymousBanner.anonymous')}
      </AnonymousWord>
      <ReactTooltip />
    </TileInfoBanner>
  );
};

export default AnonymousBannerComponent;
